/* eslint-disable */
import ctype from 'component-type';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the type of a given `key` is invalid
 * @export
 * @class I18nInvalidKeyTypeError
 * @extends {Error}
 */
export class I18nInvalidKeyTypeError extends Error {
  /**
   * Creates an instance of I18nInvalidKeyTypeError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidKeyTypeError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidKeyTypeError`;
  }
}

/**
 * Called when the type of a given `key` is invalid
 * @param {any} key The invalid `key`
 * @returns {never} never
 */
const throwI18nInvalidKeyTypeError = (key) => {
  throw new I18nInvalidKeyTypeError(
    stripIndent(`
    Expected "key" to be of type String.
    Got: "${ctype(key)}".
    `),
  );
};

export default throwI18nInvalidKeyTypeError;
